/* eslint-disable react/jsx-no-undef */
import React from "react";
import Input from "../Input/Input";
import "./Card.styles.css";
import Button from "../Button/Button";
const onClickHandler = (event) => {
    event.target.preventDefault();
}
function Card() {
  return (
    <section className="Card">
        <Input placeholder={"First Name"} type={"text"} />
        <Input placeholder={"Last Name"} type={"text"} />
        <Input placeholder={"Email Address"} type={"email"} />
        <Input placeholder={"Password"} type={"password"} />
        <Button text={"CLAIM YOUR FREE TRIAL"} type={"submit"} handleClick={() => onClickHandler()} backgroundColor={'rgb(102, 218, 102)'}/>
    </section>
  );
}
export default Card;
